import React from "react";
import Modal from "../../components/Modal";
import i18n from "../../i18n";
import FileChooseButton from "../../components/FileChooseButton";
import TouchEffect from "../../components/TouchEffect/TouchEffect";
import {assetUrl} from "../../utils/etc";

export default class BadUploadPhotoModal extends Modal {

  componentDidMount() {
    // window.webviewEventsListeners.backPress.push(() => {
    //   this.dismiss();
    //   return true;
    // });
  }

  dismiss(trigger) {
    // window.webviewEventsListeners.backPress.pop();
    super.dismiss(trigger);
  }

  handleFileChooseButtonClick = () => {
    this.props.onFileChooseButtonClick && this.props.onFileChooseButtonClick();
  }

  handleFilesSelected = (files) => {
    this.props.onFilesSelected(files);
    this.dismiss();
  };

  handleSubscribeClick = () => {
    this.props.onSubscribe();
    this.dismiss();
  };

  renderModal() {
    return <React.Fragment>
      <h2 dangerouslySetInnerHTML={{__html: i18n.t("bad_upload_photo_title_modal")}} />
      <p dangerouslySetInnerHTML={{__html: i18n.t("bad_upload_photo_text_modal")}} />

      <div className="images-container">
        <div className="portrait-image-container">
          <div className="portrait-image-1">
            <img src={this.props.photoUrl} alt="" />
            <div className="portrait-image-text">
              <SvgCloseIcon />
              <p dangerouslySetInnerHTML={{__html: i18n.t("bad_upload_photo_bad_text_modal")}} />
            </div>
          </div>
          <div className="portrait-image-2">
            <img src={this.props.photoUrl} alt="" />
          </div>
        </div>
        <div className="portrait-image-container">
          <div className="slide slide-1">
            <div className="portrait-image-1">
              <img src={assetUrl("assets/images/1res.jpg")} alt="" />
              <div className="portrait-image-text">
                <SvgCheckIcon />
                <p dangerouslySetInnerHTML={{__html: i18n.t("bad_upload_photo_good_text_modal")}} />
              </div>
            </div>
            <div className="portrait-image-2">
              <img src={assetUrl("assets/images/1orig.jpg")} alt="" />
            </div>
          </div>
          <div className="slide slide-2">
            <div className="portrait-image-1">
              <img src={assetUrl("assets/images/2res.jpg")} alt="" />
              <div className="portrait-image-text">
                <SvgCheckIcon />
                <p dangerouslySetInnerHTML={{__html: i18n.t("bad_upload_photo_good_text_modal")}} />
              </div>
            </div>
            <div className="portrait-image-2">
              <img src={assetUrl("assets/images/2orig.jpg")} alt="" />
            </div>
          </div>
          <div className="slide slide-3">
            <div className="portrait-image-1">
              <img src={assetUrl("assets/images/3res.jpg")} alt="" />
              <div className="portrait-image-text">
                <SvgCheckIcon />
                <p dangerouslySetInnerHTML={{__html: i18n.t("bad_upload_photo_good_text_modal")}} />
              </div>
            </div>
            <div className="portrait-image-2">
              <img src={assetUrl("assets/images/3orig.jpg")} alt="" />
            </div>
          </div>
        </div>
      </div>

      <button className="btn-upload-foto" onClick={this.handleSubscribeClick}>
        {i18n.t("subscribe")}
        <TouchEffect />
      </button>

      <FileChooseButton
        className="btn"
        onClick={this.handleFileChooseButtonClick}
        onFilesSelected={this.handleFilesSelected}>
        {i18n.t("change")}
        <TouchEffect />
      </FileChooseButton>

    </React.Fragment>;
  }
}

function SvgCloseIcon() {
  return <svg viewBox="0 0 40 40">
    <defs>
      <clipPath id="a5qib6izza">
        <path d="M1242 0v2208H0V0h1242z" />
      </clipPath>
      <clipPath id="b4aegi3gwb">
        <path d="m36 0 4 4-16 16 16 16-4 4-16-16L4 40l-4-4 16-16L0 4l4-4 16 16L36 0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#a5qib6izza)" transform="translate(-423 -1001)">
      <g clipPath="url(#b4aegi3gwb)" transform="translate(423 1001)">
        <path fill="#EA0E0E" d="M0 0h40v40H0V0z" />
      </g>
    </g>
  </svg>;
}

function SvgCheckIcon() {
  return <svg viewBox="0 0 54 40">
    <defs>
      <clipPath id="b3lj3xfkka">
        <path d="M1242 0v2208H0V0h1242z" />
      </clipPath>
      <clipPath id="136jkz3sdb">
        <path d="m49.037 0 4.296 4.222L16.963 40 0 23.333l4.296-4.222 12.667 12.445L49.037 0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#b3lj3xfkka)" transform="translate(-766 -1420)">
      <g clipPath="url(#136jkz3sdb)" transform="translate(766 1420)">
        <path fill="#5EB106" d="M0 0h53.333v40H0V0z" />
      </g>
    </g>
  </svg>;
}